import {animate, state, style, transition, trigger} from '@angular/animations';

export const EnterFromBottom = trigger('enterFromBottom', [
    transition(':enter', [
        style({transform: 'translateY(100%)', opacity: 0, height: 0, marginTop: 0}),
        animate(500, style({transform: 'translateY(0%)', opacity: 1, height: 84, marginTop: 10}))
    ]),
]);

/**
 * Использование [@countdown]="{value: 'end', params: {timeout: config.timeout}}"
 */
export const Countdown = trigger('countdown', [
    state('end', style({
        width: 0
    })),
    transition('*=>end', [
        style({width: '100%'}),
        animate('{{timeout}}ms')
    ], {params : {timeout: 30000}}),
]);

export const LeaveCollapse = trigger('leaveCollapse', [
    transition(':leave', [
        animate(200,  style({opacity: 0, height: 0, marginTop: 0}))
    ])
]);
